module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-five-o-three"
  }, [_c('div', {
    staticClass: "p-five-o-three__container"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 72.4 72.2"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M36.3 0C16.2 0 0 16.2 0 36.1s16.2 36.1 36.3 36.1S72.4 56 72.4 36.1 56.1 0 36.3 0zm0 61.4c-14 0-25.3-11.3-25.3-25.3s11.3-25.3 25.3-25.3S61.6 22 61.6 36.1 50.1 61.4 36.3 61.4z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M68.8 70.7c-2.2 1.9-5.8 1.7-7.7-.6L55 63.2c-1.9-2.2-1.7-5.8.6-7.7 2.2-1.9 5.8-1.7 7.7.6l6.1 6.9c1.9 2.5 1.6 5.8-.6 7.7z"
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("503 Error")]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("We are currently experiencing some technical issues."), _c('br'), _c('br'), _vm._v(" Our Developers are working hard to deploy fixes as a high priority. For more information contact "), _c('strong', {
    staticClass: "strong-503"
  }, [_vm._v("Chris McCrudden")]), _vm._v(" on "), _c('strong', {
    staticClass: "strong-503"
  }, [_vm._v("0203 871 9971")]), _vm._v(" or "), _c('a', {
    attrs: {
      "href": "mailto:abcquantum@bc-legal.co.uk"
    }
  }, [_c('strong', [_vm._v("contact us.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5a295f9f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/503/503.vue
// module id = 1708
// module chunks = 0